export default __webpack_public_path__ + "static/media/phone_icon.c195dc29.svg";